import React, { Component } from 'react';
import _ from 'lodash';
import { Link, withRouter } from 'react-router-dom';
import { InfoLabel, Icon, Loader, FormattedDateRange } from '@jutro/components';

import PropTypes from 'prop-types';
// import { SelectProducerCode } from 'gw-gateway-common-react';
import { PolicyService } from 'gw-capability-policy';
import { GatewayPolicyService, UserService } from 'gw-capability-ri-policy';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { withIntl, TranslatorContext } from '@jutro/locale';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { isCapabilityEnabled } from 'gw-portals-config-js';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import { DependencyProvider } from 'gw-portals-dependency-react';
import { PolicyBilling, AuditStatements } from 'gw-capability-ri-policy-react';

// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import FormattedHeaderComponent from '../../../gw-capability-ri-policy-react/Components/FormattedHeaderComponent/FormattedHeaderComponent';
import CommonRoutes from '../../Common/CommonRouting';
import pageRouting from '../../Common/Billing-config.json5';
import styles from './BillingLanding.module.scss';
import metadata from './BillingLanding.metadata.json5';
import messages from '../../Billing.messages';

const { gatewayParamConfig = {} } = appConfig;
const { capabilitiesConfig } = appConfig;

const DocumentPageService = {
    getDocuments: GatewayPolicyService.getDocumentsForPolicy,
    generateUploadToken: GatewayDocumentService.generateUploadToken,
    uploadDocument: GatewayDocumentService.uploadDocument,
    removeDocument: GatewayDocumentService.removeDocument,
    downloadDocument: GatewayDocumentService.downloadDocument
};

class BillingLanding extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        match: PropTypes.shape({
            path: PropTypes.string,
            url: PropTypes.string
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired,
        isLoggedIn: PropTypes.bool,
        location: PropTypes.shape({
            state: PropTypes.string,
            pathname: PropTypes.string
        }).isRequired
    };

    state = {
        currentView: undefined,
        isLoading: true,
        selectedProducerCode: 'all',
        selectedHeaderContent: messages.recentlyViewed,
        policyResponse: {},
        policyBillingData: {},
        isDirectBill: true,
        policyTerm: '',
        insuredName: ''
    };

    componentDidMount() {
        this.getBillingDetails();
    }


    componentDidUpdate(prevProps) {
        if(prevProps.match.params.policyNumber != this.props.match.params.policyNumber) {
            this.setState({
                isLoading: true,
            });
            this.getBillingDetails();
        }
    }    

    getRoutesWithFeature() {
        const routes = [...pageRouting];
        this.billingSummaryActive(routes);
        return routes;
    }

    billingSummaryActive = (routes) => {
        if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' })) {
            const summaryRoute = {
                path: '/summary',
                component: PolicyBilling
            };
            routes.push(summaryRoute);

            const auditRoute = {
                path: '/audits',
                component: AuditStatements
            };
            routes.push(auditRoute);
        }
    };

    getBillingDetails = async () => {
        const {
            isLoggedIn,
            authHeader,
            match: {
                params: { policyNumber }
            },
            location: { state: redirectPath, pathname }
        } = this.props;
        /* Get policy Summaries */

        let defaultPolicy = policyNumber;
        await PolicyService.getAccountPolicySummaries(authHeader).then(
            (getPolicyResponse = {}) => {
                if (!_.isUndefined(getPolicyResponse) && !(Object.keys(getPolicyResponse).length === 0)) {
                    const routePath = pathname && (pathname.trim().split('/') || []);
                    const selectedPageFromPath = routePath[routePath.length - 1];
                    const activeTile = selectedPageFromPath || redirectPath || 'terms'; // FB 15920
                    getPolicyResponse.numberOfDocuments = 0;
                    if (_.isEmpty(policyNumber)) {
                        defaultPolicy = _.get(getPolicyResponse[0].periods, '[0].policyId');
                        return this.props.history.push(`/ri-billing/${defaultPolicy}/terms`); // FB 15920
                    }
                    this.setState({
                        currentView: activeTile,
                        policyResponse: getPolicyResponse,
                        insuredName: _.get(getPolicyResponse[0].periods, '[0].displayNameExt')
                    });
                }
            }
        );

        await GatewayPolicyService.getPolicyBillingSummaryInfo(defaultPolicy, authHeader).then(
            (billingResponseData = {}) => {
                if (!_.isUndefined(billingResponseData.policyPeriodBillingSummaries)) {
                    const billingData = billingResponseData.policyPeriodBillingSummaries;
                    const billingMethod = _.get(billingData, '[0].billingMethod');
                    const billingIcon = _.get(billingData, '[0].isDelinquent')
                        ? 'mi-warning'
                        : 'mi-payment';
                    this.setState({
                        policyBillingData: billingResponseData,
                        billingIcon: billingIcon,
                        isDirectBill: billingMethod === 'DirectBill'
                    });
                    this.updateDocumentCount();
                } else {
                    const billingIcon = 'mi-payment';
                    this.setState({
                        billingIcon: billingIcon
                    });
                }
            }
        );
        this.setState({
            isLoading: false,
            policyTerm: defaultPolicy
        });
    };

    handleTilesOnClick = (id) => {
        this.setState({ currentView: id });
    };

    handleAccountNumberOnClick = () => {
        this.handleTilesOnClick('terms');
    };

    getBillingHeader = (policyBillingData, policyHolderName) => {
        if (_.isEmpty(policyBillingData)) {
            return null;
        }
        const billingStatus = _.get(policyBillingData.policyPeriodBillingSummaries, '[0].accountStatus_Ext');
        const billingNumber = policyBillingData.policyPeriodBillingSummaries[0].billingAccountNumber_Ext;
        const policyStatus = _.get(policyBillingData.policyPeriodBillingSummaries, '[0].policyStatus_Ext');
        const policyNumber = _.get(policyBillingData.policyPeriodBillingSummaries, '[0].policyNumber');
        const activePeriod = _.get(policyBillingData.policyPeriodBillingSummaries, '[0]');
        const statusClassName = billingStatus === 'Delinquent' ? styles.riInfoStatusAlert : styles.gwInfoStatus;
        return (
            <div>
                <div className={styles.riSubTitle}>
                    <div>
                        Account #: &nbsp;
                        <span>
                            <Link to={`/ri-billing/${policyNumber}/summary`} className={styles.riLinkDetails}>
                                {billingNumber}
                            </Link>
                        </span>
                        <InfoLabel
                            id="infoStatus"
                            size="medium"
                            className={statusClassName}
                            type="info"
                            message={billingStatus}
                        />
                    </div>
                    <div className={styles.riSubTitle}>
                        Policy #: &nbsp;
                        <span>
                            <Link to={`/ri-policies/${policyNumber}/summary`} className={styles.riLinkDetails}>
                                {policyNumber}
                            </Link>
                        </span>
                        <span className={styles.riEffDateGroup}>
                            (
                            <FormattedDateRange
                                id="effectiveDate_1"
                                value={activePeriod}
                                startDate={new Date(activePeriod.effectiveDate)}
                                endDate={new Date(activePeriod.expirationDate)}
                                hideLabel
                                displayFormat="short"
                            />
                            )
                        </span>
                        <InfoLabel
                            id="infoStatus"
                            size="medium"
                            className={styles.gwInfoStatus}
                            type="info"
                            message={policyStatus}
                        />
                    </div>
                </div>
                <div className={styles.riTypeWithLOB}>
                    <div>
                        <Icon icon="mi-receipt" className={styles.syncIcon} />
                    </div>
                    <div>
                        <h2>{policyHolderName}</h2>
                    </div>
                </div>
            </div>
        );
    };

    // getBillingHeader = (policyBillingData) => {
    //     if (_.isEmpty(policyBillingData)) {
    //         return null;
    //     }
    //     const acctStatus = _.get(policyBillingData.policyPeriodBillingSummaries, '[0].accountStatus_Ext');
    //     const billingNo = policyBillingData.policyPeriodBillingSummaries[0].billingAccountNumber_Ext;
    //     const redirectpath = `/ri-billing/${policyBillingData.policyPeriodBillingSummaries[0].billingAccountNumber_Ext}/terms`;
    //     const statusClassName = acctStatus === 'Delinquent' ? styles.riInfoStatusAlert : styles.gwInfoStatus;
    //     return (
    //         <div className={styles.gwTypeWithLOB}>

    //             <Icon icon="mi-receipt" className={styles.syncIcon} />

    //             <h1 className={styles.gwPageTitle}>
    //                 {messages.billingTitle.defaultMessage}
    //             </h1>

    //             <span className={styles.riAccountNumberParentheses}>
    //                 {`(`}

    //                 <Link to={redirectpath}
    //                     className={styles.riAccountNumberLink}
    //                     onClick={this.handleAccountNumberOnClick}
    //                 >
    //                     {billingNo}
    //                 </Link>

    //                 {`)`}
    //             </span>

    //             <InfoLabel
    //                 id="infoStatus"
    //                 size="medium"
    //                 className={statusClassName}
    //                 type="info"
    //             >
    //                 {acctStatus}
    //             </InfoLabel>
    //         </div>
    //     );
    // };

    // FB 15920 -----
    getInsuredName = (insuredName, policy) => {
        const redirectpath = `/ri-policies/${policy}/summary`;
        return (
            <div>
                <span className={styles.insuredNameLabel}>
                    Insured Name:
                </span>

                <Link
                    to={redirectpath}
                    className={styles.insuredNameText}
                >
                    {insuredName}
                    {' '}
                    {'('}
                    {policy}
                    {')'}
                </Link>
            </div>
        );
    };
    // ----- FB 15920

    updateCountInfo = (type) => {
        const { policyResponse } = this.state;
        const currentCount = _.get(policyResponse, `numberOf${type}`);
        _.set(policyResponse, `numberOf${type}`, currentCount + 1);
        alert(currentCount);
        this.setState({ policyResponse });
    };

    updateDocumentCount = (type = 'Documents') => {
        const { policyResponse, policyBillingData } = this.state;
        if (_.isEmpty(policyBillingData)) {
            return null;
        }
        const countInvoice = policyBillingData.policyPeriodBillingSummaries[0].invoiceStatements_Ext.length;
        const countEarnedPremium = policyBillingData.policyPeriodBillingSummaries[0].earnedPremiumStatements_Ext.length;
        const countPastDueInvoice = policyBillingData.policyPeriodBillingSummaries[0].pastDueInvoiceStatements_Ext.length;
        const countX = 0;

        const count = countInvoice + countEarnedPremium + countPastDueInvoice + countX;
        _.set(policyResponse, `numberOf${type}`, count);
        this.setState({ policyResponse });
    };

    render() {
        const {
            policyResponse,
            currentView,
            isLoading,
            billingIcon,
            policyBillingData,
            isDirectBill,
            policyTerm,
            insuredName
        } = this.state;
        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }

        if (_.isEmpty(policyResponse)) {
            return null;
        }

        const overrides = {
            [currentView]: {
                active: true
            },
            billing: {
                active: currentView === 'billing',
                tileIcon: billingIcon,
                visible: isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' })
            },
            tabBillingSummaryTitle: {
                content: this.getBillingHeader(policyBillingData, insuredName)
            },
            billingTileContainer: {
                visible: isDirectBill
            },
            billingInfoContainer: {
                visible: isDirectBill
            },
        };

        const resolvers = {
            resolveComponentMap: {
            },
            resolveCallbackMap: {
                handleTilesOnClick: this.handleTilesOnClick,
                handleAccountNumberOnClick: this.handleAccountNumberOnClick
            },
            resolveClassNameMap: styles
        };
        const {
            match: { url },
            match: {
                params: { policyNumber }
            },
        } = this.props;

        const policyDetailsData = {
            policyResponse: policyResponse
        };
        return (
            <DependencyProvider value={{ DocumentPageService }}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={policyResponse}
                    overrideProps={overrides}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    classNameMap={resolvers.resolveClassNameMap}
                />
                <CommonRoutes
                    steps={this.getRoutesWithFeature()}
                    basePath={url}
                    setDocumentCount={this.updateDocumentCount}
                    policyNumber={policyNumber}
                    policyDetailsData={policyDetailsData}
                    billingData={policyBillingData}
                />
            </DependencyProvider>
        );
    }
}

export default withRouter(withAuthenticationContext(BillingLanding));
